import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import { useSelector } from 'react-redux';
import Tools from '../tools/tools';
import { Redirect } from 'react-router-dom';
import keycloak from '../tools/keycloak';

const RequestDocuments = (props) => {
    let [data, setData] = useState();
    let [mainData, setMainData] = useState();
    let [fileModalVisible, setfileModalVisible] = useState(false);
    const requestId = sessionStorage.getItem("requestId");
    const canBeEdited = (resultStateId) => {
        return keycloak.userInfo.preferred_username === mainData.givenTo;
    }

    const fetchData = async () => {
        if (!requestId) {
            return;
        }

        setData(null);

        Comm.Instance().get(`document?entity=request&id=${requestId}`).then(result => {
            setData(result.data).catch(error => Tools.ProcessError(error));

        }).catch(message => {

            toast.error(message);
        })
        setMainData(null);
        Comm.Instance().get(`request?requestId=${requestId}`).then(result => {
            setMainData(result.data);

        }).catch(error => Tools.ProcessError(error))

    };
    useEffect(() => {

        fetchData();
    }, []);

    const del = (documentId) => {
        Comm.Instance().delete(`document?entity=request&entityId=${requestId}&documentId=${documentId}`).then(result => {

            fetchData();
        }).catch(error => Tools.ProcessError(error))
    }

    const addConnection = (documentId) => {
        setfileModalVisible(false);
        if (!documentId)
            return;
        let data = {
            documentId: documentId,
            entityId: parseInt(requestId)
        };
        console.log("data", data);
        Comm.Instance().put(`document?entity=request`, data).then(result => {

            fetchData();
        }).catch(error => Tools.ProcessError(error))
    }

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }



    if (!data || !mainData)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!data}
                />
            </div>
        );
    return (
        <>
            <div className="container">
                <h2 className="appeal-title mb-5">{mainData.numName} {mainData.name}</h2>


                <div className="form-row">
                    <div className="form-group col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Документ
                                    </th>
                                    <th>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map(i =>
                                        <tr key={i.documentId}>
                                            <td>
                                                <a href={'documentcontent?documentId=' + i.documentId} title={i.remark} alt={i.remark}>{i.title}</a>

                                            </td>
                                            <td>
                                                {
                                                    mainData.requestStateId === 1 ?
                                                        <button className="btn btn-danger" onClick={() => del(i.documentId)}>Премахване</button>
                                                        : null
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="container">
                
                {canBeEdited(mainData.requestStateId) ? <button type="button" className="btn btn-primary" onClick={() => setfileModalVisible(true)}>Нов документ</button> : null}
            </div>
            <ModalUpload display={fileModalVisible} closeFunc={(val) => addConnection(val)} />
        </>

    );
}


export default RequestDocuments;

